<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Agendamentos"
    >
        O paciente possui o(s) seguinte(s) agendamento(s):<br><br>

        <rkm-table
            :fields="fields"
            :items="itens"
            hide-filters
            hide-pagination
            sort-by="text"
        />

        <br>

        Deseja continuar?

        <template v-slot:footer>
            <rkm-button
                @click="confirm"
                color="primary"
            >
                Sim
            </rkm-button>

            <rkm-button @click="close">
                Não
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

export default {
    data() {
        return {
            fields: [
                {key: 'data', label: 'Data viagem', formatter: v => this.formatDate(v), sortable: true},
                {key: 'motivoDescricao', label: 'Motivo', sortable: true},
                {key: 'municipio', label: 'Município', sortable: true},
                {key: 'destino', label: 'Local consulta', sortable: true},
                {key: 'horario', label: 'Horário', sortable: true},
                {key: 'veiculoDescricao', label: 'Veículo', sortable: true},
                {key: 'jornadaDescricao', label: 'Jornada', sortable: true},
                {key: 'observacao', label: 'Observação'},
            ],
            itens: [],
            onConfirm: null
        }
    },
    methods: {
        open(itens, onConfirm) {
            this.itens = itens
            this.onConfirm = onConfirm

            this.$refs.RkmModal.show()
        },
        confirm() {
            this.onConfirm()
            this.close()
        },
        close() {
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [formats],
}
</script>